/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import Config from "data/config";
// import useOrganization from 'hooks/useOrganization'
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { formatTime } from "./format-time";
import { Logger } from "cms/utils/log/logger";

const TimeFieldDisplay = () => {
    
    // const organization = useOrganization() || {}
    const { field } = useCurrentDynamicField();
    const { values } = field || {};
    
    return (
        <FieldDisplayWrapper>
            {values &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { date, tz = Config.dates.timezone } = value || {};
                    const { style, format } = settings || {};
                    let dateVal;
                    try {
                        dateVal = formatTime(date, tz, format);
                    } catch (e) {
                        Logger.error(e);
                        return null;
                    }

                    return (
                        <Fragment key={index}>
                            {/*{dateInZone.toDate()}*/}
                            <DisplayTextOnly value={dateVal} style={style} />
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
TimeFieldDisplay.displayName = "TimeFieldDisplay";
export { TimeFieldDisplay };
